import React, { SVGProps } from "react"

const CalendarIcons = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M2.08334 7.91666H17.9167V16.6667C17.9167 16.8877 17.8289 17.0996 17.6726 17.2559C17.5163 17.4122 17.3043 17.5 17.0833 17.5H2.91667C2.69566 17.5 2.48369 17.4122 2.32741 17.2559C2.17113 17.0996 2.08334 16.8877 2.08334 16.6667V7.91666Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.08334 3.74999C2.08334 3.52898 2.17113 3.31701 2.32741 3.16073C2.48369 3.00445 2.69566 2.91666 2.91667 2.91666H17.0833C17.3043 2.91666 17.5163 3.00445 17.6726 3.16073C17.8289 3.31701 17.9167 3.52898 17.9167 3.74999V7.91666H2.08334V3.74999Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66666 1.66666V4.99999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 1.66666V4.99999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 14.1667H14.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83334 14.1667H8.33334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6667 10.8333H14.1667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83334 10.8333H8.33334"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default CalendarIcons
